import { CommonModule } from '@angular/common';
import {
    TemplateRef,
    ContentChild,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Output,
    Component,
    Input,
    EventEmitter
} from '@angular/core';
import { Logger } from '@df/core/service/logger';
import { OffClickModule } from '@df/module-off-click/off-click.module';
import { LineHeightByComponent } from '@df/ui/common/line-height-by.component';
import { HideUpComponent } from '@df/ui/hide-up/hide-up.component';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { BehaviorSubject } from 'rxjs';

@Component({
    standalone: true,
    imports: [OffClickModule, ToggleModule, LineHeightByComponent, CommonModule, HideUpComponent],
    selector: 'listing-dropdown',
    templateUrl: './listing-dropdown.html',
    styleUrls: ['./listing-dropdown.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductListingDropdownComponent<T> {
    /**
     * No selection placeholder
     */
    @Input()
    placeholder?: string;

    /**
     * Selected value
     */
    @Input()
    value?: T;

    /**
     * Value output
     */
    @Output()
    valueChange = new EventEmitter<T>();

    /**
     * Options to print
     */
    @Input()
    options?: T[];

    @Input()
    closeAfterSelect = true;

    @Input()
    optionsAsGrid = false;

    /**
     * If is open
     */
    readonly openState = new BehaviorSubject(false);

    /**
     * Title presentation teplate
     */
    @ContentChild('titleTpl', { static: false })
    titleTpl?: TemplateRef<any>;

    /**
     * Option presentation template
     */
    @ContentChild('optionTpl', { static: false })
    optionTpl?: TemplateRef<any>;

    /**
     * Dependencies
     */
    constructor(
        private cd: ChangeDetectorRef,
        private logger: Logger
    ) {}

    /**
     * Toggle state
     */
    toggle(to = !this.openState.value) {
        this.openState.next(to);
        this.detectChanges();
    }

    pick(option: T) {
        if (this.value === option) {
            return;
        }
        if (this.closeAfterSelect) {
            this.toggle(false);
        }
        this.valueChange.emit((this.value = option));
    }

    private detectChanges() {
        this.cd.detectChanges();
    }

    get numberOfRows() {
        return this.options?.length > 4 ? Math.ceil(this.options?.length / 4) : this.options?.length;
    }
}
